// These need to be here to avoid circular dependencies

export const ROUTE_ID = ":id";

export const AI_ROUTES = {
  ScreenshotRecommendations: "/ai/test-pilot",
};

export const ADMIN_ROUTES = {
  AdminOverview: "/admin/overview",
  Agencies: "/admin/agencies",
  Ai: "/admin/ai",
};

export const WIDGET_ROUTES = {
  WidgetLibrary_Experiences: "/widget-library/experiences",
  WidgetLibrary_Sitewide: "/widget-library/sitewide",
};

export const GLOBAL_STYLES_ROUTES = {
  GlobalStyles_Experiences: "/global-styles/experiences",
  GlobalStyles_Sitewide: "/global-styles/sitewide",
};

export const GENERAL_ROUTES = {
  Index: "/",
  Home: "/home",
  ConfigHandler: "/config-handler",
  Readme_Login: "/readme/login",
  Integrations: "/integrations",
  GoogleIntegrationCallback: "/integrations/google-callback",
  NotSubscribed: "/not-subscribed",
  Performance: "/performance",
  Logout: "/logout",
  IntelligemsAi: "/intelligems-ai",
  ConfigCompare: "/config-compare",
  EventsManager: "/events-manager",
  ManagePlans: "/manage-plans",
  Offers: "/offers",
  SitewideAnalytics: "/sitewide-analytics",
} as const;

export const SETTINGS_ROUTES = {
  Settings_Advanced: "/settings/advanced",
  Settings: "/settings",
} as const;

export const PERSONALIZATION_ROUTES = {
  Personalizations: "/personalizations",
  Personalization: "/personalization",
  Personalization_Id: "/personalization/:id?",
} as const;

export const EXPERIENCE_ROUTES = {
  Experiences: "/experiences",
  Experiences_Offers: "/experiences/offers",
  Experiences_SiteContent: "/experiences/site-content",
  Experience: "/experience",
  Experience_Id: "/experience/:id?",
} as const;

export const EXPERIMENT_ROUTES = {
  Experiments: "/experiments",
  Experiment: "/experiment",
  Experiment_Id: "/experiment/:id?",
  Compare: "/compare",
  Compare_Id: "/compare/:id",
} as const;

export const OLD_EXPERIMENT_ROUTES = {
  Experiences: "/experiences",
  Compare: "/compare",
  Compare_Id: "/compare/:id",
  ContentTest: "/content-test",
  ContentTest_Id: "/content-test/:id?",
  PriceTest: "/price-test",
  PriceTest_Id: "/price-test/:id?",
  ShippingTest: "/shipping-test",
  ShippingTest_Id: "/shipping-test/:id?",
  OfferTest: "/offer-test",
  OfferTest_Id: "/offer-test/:id?",
  DuplicateProducts: "/duplicate-products",
  DuplicateProducts_Id: "/duplicate-products/:id",
} as const;

export const OLD_DASHBOARD_ROUTES = {
  Dashboard: "/dashboard",
  Dashboard_Overview: "/dashboard/overview",
  Dashboard_Overview_Id: "/dashboard/overview/:id",
  Dashboard_Profit: "/dashboard/profit",
  Dashboard_Profit_Id: "/dashboard/profit/:id",
  Dashboard_Revenue: "/dashboard/revenue",
  Dashboard_Revenue_Id: "/dashboard/revenue/:id",
  Dashboard_Shipping: "/dashboard/shipping",
  Dashboard_Shipping_Id: "/dashboard/shipping/:id",
  Dashboard_Visitors: "/dashboard/visitors",
  Dashboard_Visitors_Id: "/dashboard/visitors/:id",
  Dashboard_Orders: "/dashboard/orders",
  Dashboard_Orders_Id: "/dashboard/orders/:id",
  Dashboard_Discounts: "/dashboard/discounts",
  Dashboard_Discounts_Id: "/dashboard/discounts/:id",
  Dashboard_ProductGroups: "/dashboard/product-groups",
  Dashboard_ProductGroups_Id: "/dashboard/product-groups/:id",
  Dashboard_Subscriptions: "/dashboard/subscriptions",
  Dashboard_Subscriptions_Id: "/dashboard/subscriptions/:id",
  Dashboard_Data_Reconciliation: "/dashboard/data-reconciliation",
  Dashboard_Data_Reconciliation_Id: "/dashboard/data-reconciliation/:id",
  Dashboard_Trend: "/dashboard/trend",
  Dashboard_StatSig: "/dashboard/statSig",
  Dashboard_AlwaysOn: "/dashboard/sitewide",
} as const;
